import { format as formatDateFns } from 'date-fns'
import { getDate } from '@Pass-It-Down/passitdown-utils'

/**
 *
 * @param {Date} date
 * @returns date converted to string.
 */
export const formatDate = function(params) {
    const { day, month, year } = params
    const date = getDate({ day, month, year })
    if(!date) return ''

    let format = 'yyyy'

    if(NotEmpty(month)) { //
        format = 'MMM ' + format
    }

    if(NotEmpty(day)) {
        format = 'MMM d, yyyy'
    }

    return formatDateFns(date, format)
}

export const NotEmpty = function(value) {
    return value !== null && value !== '' && value !== undefined
}
